import React, {Component} from 'react';
import { push } from 'react-router-redux'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';
import styled from 'styled-components';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';

import Button from '../../components/Button/Button';
import StyledField from '../../components/StyledField/StyledField';
import { Formik, Field, FieldArray } from 'formik';

import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase'

import { bindActionCreators, compose } from 'redux';
import * as folioActions from '../../actions/folio-actions';

import '../../styles.scss';
import FileUpload from "../../components/FileUpload/FileUpload";
import Icon from "../../components/Icon/Icon";
import {RichTextCleaner} from "../../components/RichTextCleaner/richTextCleaner";

const ThumbnailWrappers = styled.div`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
`;

const Thumbnail = styled.div`
  img {
    width: auto;
    height: auto;
  }
`;

const ThumbnailWrapper = styled.div`
  display: flex;
  margin: 0;
  padding: 0 20px 20px 0;
  
  img {
    height: auto;
    display: block;
    max-width: 150px;
  }
`;

const ThumbnailWrapperControls = styled.div`
  display: flex;
  margin: 0;
`


const UploadLabel = styled.label`
  align-content: center;
  background-color: steelblue;
  color: white;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
  text-align: center;
  padding: 10px 4px 2px 4px;
  height: 40px;
  display: ${({ inline }) => inline ? 'inline-block' : 'block' };
  
  & > div {
    display: none;
  }
`;

const Tag = styled.div`
  display: ${({ inline }) => inline ? 'inline-block' : 'block' };
  text-align: center;
  
  input, select {
    text-transform: uppercase;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    margin-left: 5px;
  }
`;

const Order = styled.div`
  display: ${({ inline }) => inline ? 'inline-block' : 'flex' };
  text-align: left;
  
  input {
    text-transform: uppercase;
    border-radius: 0;
    width: 40px;
    height: 40px;
  }
`;

const Select = styled.select`
  margin-top: 3px;
  width: 100%;
`

const Hint = styled.div`
    margin-top: 4px;
`

const StorySection = styled.section`
`

class AdminTabs extends Component {
  render() {
    return <ul className="tabs">
      <li><Link to="/admin/projects">Projects</Link></li>
      <li className="active"><Link to="/admin/stories">Stories</Link></li>
    </ul>;
  }
}

AdminTabs.propTypes = {
  handleSelection: PropTypes.any,
  activeTab: PropTypes.string,
  handleLogout: PropTypes.func
};

class ContentContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 'stories',
      editorBody: EditorState.createEmpty(),
      editorTeaser: '',
      editorLede: '',
      name: '',
      title: '',
      path: '',
      section: '',
      order: 0,
      clone: false,
      newImageTag: '',
      id: props.storyId|| 0
    }
  }

  componentDidMount() {
    const selectedStory = this.props.stories && this.props.stories[this.props.storyId];

    if (selectedStory && selectedStory.body) {
      const id = this.props.storyId || this.state.id;


      this.setState(
          {
            editorBody: EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(selectedStory.body).contentBlocks)),
            editorTeaser: selectedStory.teaser,
            editorLede: selectedStory.lede,
            title: selectedStory.title,
            path: selectedStory.path,
            section: selectedStory.section,
            name: selectedStory.name,
            published: selectedStory.published,
            media: selectedStory.media,
            id: id,
            order: selectedStory.order,
            clone: false,
          }
      )
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.auth.isLoaded && this.props.auth.isEmpty) {
      this.props.actions.redirectToLogin();
    }

    if (this.props.stories !== prevProps.stories) {
      const selectedStory = this.props.stories && this.props.stories[this.props.storyId];

      if (selectedStory && selectedStory.body) {
        const id = this.props.storyId || this.state.id;

        this.setState(
            {
              editorBody: EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(selectedStory.body).contentBlocks)),
              editorTeaser: selectedStory.teaser,
              editorLede: selectedStory.lede,
              title: selectedStory.title,
              path: selectedStory.path,
              section: selectedStory.section,
              name: selectedStory.name,
              published: selectedStory.published,
              media: selectedStory.media,
              id: id,
              order: selectedStory.order,
              clone: false
            }
        )
      }
    }
  }



  // File handling.
  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
  handleProgress = (progress) => this.setState({ progress });
  handleUploadError = () => { this.setState({ isUploading: false }); };
  handleUploadSuccess = (filename, item, tag) => {
    this.setState({ [item]: filename, progress: 100, isUploading: false });
    this.props.firebase.storage().ref('stories').child(filename).getMetadata().then(data => {
      const media = [ ...this.state.media ];
      const index = item < 1  ? media.length + 1 : item;
      media[index] = {
        tag: tag,
        url: data.downloadURLs[0]
      };
      this.setState({ media });
    })
  };

  // Handlers.
  handleTabSelection = (selection) => {
    this.setState( () => ({ activeTab: selection }));
  };

  selectProject = (e, id) => {
    e.preventDefault();
    this.props.navAdd(id);
  };

  handleDeleteProject = (e, project) => {
    e.preventDefault();
    this.props.firebase.ref('projects').child(project).remove().then(() => {
      this.props.actions.showNotification('Project deleted.');
      setTimeout(() => { this.props.actions.hideNotification(); }, 8000);
    });
  };

  onEditorBodyChange = (editorBody, setFieldValue) => {
    const copy = convertToRaw(editorBody.getCurrentContent());
    setFieldValue('body', draftToHtml(copy));
    this.setState({ editorBody });
  };

  saveData = (values) => {
    const { firebase, actions, match } = this.props;
    if (values.clone) {
      firebase.ref('stories').push(values).then((response) => {
        this.setState({ id: response.ref.key });
        actions.showNotification('Story cloned.');
        setTimeout(() => { actions.hideNotification(); }, 8000);
      });
      return;
    }
    if (this.props.storyId !== 0) {
      firebase.ref('stories').child(this.props.storyId).set(values).then(() => {
        actions.showNotification('Story updated.');
        setTimeout(() => {
          actions.hideNotification();
        }, 8000);
      })
    } else {
      firebase.ref('stories').push(values).then((response) => {
        this.setState({ id: response.ref.key });
        actions.showNotification('Story published.');
        setTimeout(() => { actions.hideNotification(); }, 8000);
      });
    }
  };


  render() {

    const selectedStory = this.props.stories
        && this.props.storyId
        && this.props.stories[this.props.storyId];

    const today = new Date();

    const initialValues = {
      modified: new Date().toLocaleDateString("en-US"),
      published: new Date().toLocaleDateString("en-US"),
      section: 'other',
    };

    return (

          <Formik
              initialValues={ selectedStory || initialValues }
              enableReinitialize
              validate={values => {
                let errors = {};
                if (!values.email) {
                  errors.email = 'Required';
                } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                  errors.email = 'Invalid email address';
                }
                return true;
              }}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  this.saveData(values, values.clone);
                  setSubmitting(false);
                }, 400);
              }}
          >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                isSubmitting,
                /* and other goodies */
              }) => (<form onSubmit={ handleSubmit } onChange={this.handleInputs} ref={ref => {
            this.form = ref
          }}>
            <StorySection className={this.state.activeTab === 'stories' ? 'tab-content is-enabled' : 'tab-content'}>

              <div>
                <div className="grid">
                  <div className="grid-item">

                    <div className="field-group">
                      <label className="label-inline">Section</label>
                      <Field type="hidden" name="modified" value={ today.toLocaleDateString('en-US') } />
                      <Field onChange={(e) => {setFieldValue('section', e.target.value)} } component={ Select } name="section" value={ values.section }>
                        <option selected={ values.section === "about"} value="about">About</option>
                        <option selected={ values.section === "process"} value="process">Process</option>
                        <option selected={ values.section === "other"} value="other">Other</option>
                      </Field>
                      {/*<Field component={ StyledField } name="section" value={values.section}/>*/}
                    </div>
                  </div>

                  <div className="grid-item">
                    <div className="field-group">
                      <label className="label-inline">URL</label>
                      <Field component={ StyledField } name="path"  value={values.path}/>
                      <Hint>Should be lower case, no spaces (hyphens ok). This will be appended to chevostudios.com</Hint>
                    </div>
                  </div>

                  <div className="grid-item">
                    <div className="field-group">
                      <label className="label-inline">Title</label>
                      <Field component={ StyledField } name="title" value={values.title}/>
                    </div>
                  </div>

                  <div className="grid-item">
                    { selectedStory && selectedStory.section === 'about' &&
                    <div className="field-group">
                      <label className="label-inline">Name</label>
                      <Field component={ StyledField } name="name" value={values.name}/>
                    </div>}
                  </div>

                  <div className="grid-item">
                    {selectedStory && selectedStory.section === 'about' &&
                    <div className="field-group">
                      <label className="label-inline">Lede</label>
                      <Field component={ StyledField } name="lede" defaultValue={values.lede} />
                    </div>}
                  </div>

                  <div className="grid-item">
                    {selectedStory && selectedStory.section === 'about' &&
                    <div className="field-group">
                      <label className="label-inline">Teaser</label>
                      <Field component={ StyledField } name="teaser" defaultValue={values.teaser} />
                    </div>}
                  </div>
                </div>

                <div className="field-group margin--top-doubled">
                  <label className="label-inline">Body</label>
                  <Editor
                      editorState={this.state.editorBody}
                      wrapperClassName="editor-wrapper"
                      editorClassName="editor-editor"
                      toolbarCustomButtons={[<RichTextCleaner />]}
                      onEditorStateChange={ (e) => { this.onEditorBodyChange(e, setFieldValue) } }
                  />
                    <Hint>If pasting from a word doc or other source, it is recommended to highlight all text and use the Clear Formatting icon (eraser) above to reset the text to plain text first.</Hint>

                </div>


                <div className="grid-item">

                  <h2>Media</h2>

                  <FieldArray name="media"
                              render={arrayHelpers => {
                                return (<ThumbnailWrappers>
                                  { values.media && values.media.map((item, i) => {
                                    return (
                                        <Thumbnail key={i}>
                                          <ThumbnailWrapper>
                                            <div>
                                              <img src={item.url} alt={item.tag}/></div>
                                            <Order>
                                              <div style={{ padding: '8px' }}>Order</div> <Field name={`media.${i}.order`} placeholder="0" defaultValue={ item.order } />
                                            </Order>
                                              <ThumbnailWrapperControls>
                                                <Tag>
                                                  <Field component="select" options={['sidebar', 'mobile', 'hero', 'hidden', 'other']} name={`media.${i}.tag`} defaultValue={ item.tag.toLowerCase() } >
                                                    <option value="background">Background</option>
                                                    <option value="hero">Hero</option>
                                                    <option value="icon">Icon</option>
                                                    <option value="main">Main (About section)</option>
                                                    <option value="mobile">Mobile (About section)</option>
                                                    <option value="secondary">Secondary (About section)</option>
                                                    <option value="sidebar">Sidebar (Process section)</option>
                                                    <option value="hidden">Hidden (upload only)</option>
                                                  </Field>
                                                </Tag>
                                                <div><UploadLabel> Upload
                                                  <FileUpload
                                                      firebase={ this.props.firebase }
                                                      directory="stories"
                                                      accept="image/*"
                                                      name={`media.${ i }.url`}
                                                  /></UploadLabel>
                                                </div>
                                                <input style={ { marginLeft: "10px", height: '40px' } } value={ item.url } readOnly />
                                                <div onClick={() => { arrayHelpers.remove(i) } }><Icon name="trash" label="Remove" inline/></div>
                                              </ThumbnailWrapperControls>
                                          </ThumbnailWrapper>
                                        </Thumbnail>)
                                  })}

                                  <div className="margin--top-doubled">
                                    <button type="button"
                                            onClick={() => values.media ? arrayHelpers.insert(values.media.length, { url: '', tag: ''}) : arrayHelpers.insert(0, { url: '', tag: '' })}
                                    >Add a photo</button></div>
                                </ThumbnailWrappers>)
                              }
                              }
                              />


                </div>
                <div style={ { marginRight: 10 }}>
                  <Field name="order" value={values.order} /> Story sort order
                </div>
                <div style={ { marginRight: 10 }}>
                  <Field type="checkbox" name="clone" defaultValue="false" checked={ values.clone }/> Clone this story
                </div>
                <Button style={ { marginTop: '10px' }}  type="submit">Publish</Button>
                <Link to="/admin/stories" style={ { marginTop: '10px', marginLeft: '10px' }} >Cancel</Link>
              </div>
            </StorySection>
          </form>)}
          </Formik>
    );
  }
}

ContentContainer.propTypes = {
  folio: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  stories: PropTypes.object
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(folioActions, dispatch),
    navAdd: (id) => { push('/add/1') } ,
    navFolio: () => { dispatch(push('/folio')) } ,
    navAdmin: () => { dispatch(push('/admin')) } ,
  }
}

export default withRouter(compose(
    firebaseConnect(['/stories']),
    connect(
        (state) => ({
          folio: state.folio,
          stories: state.firebase.data.stories,
          auth: state.firebase.auth
        }), mapDispatchToProps
    )
)(ContentContainer))



// WEBPACK FOOTER //
// ./src/containers/content/content.js